// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PCloseOutlinedSvg from "@fishx/icons-svg/es/asn/PCloseOutlined";
import FishxIcon from '../components/FishxIcon';

var PCloseOutlined = function PCloseOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PCloseOutlinedSvg
  }));
};

PCloseOutlined.displayName = 'PCloseOutlined';
export default React.forwardRef(PCloseOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PCloseOutlined.js
// module id = 3283
// module chunks = 0